import axiosInstance from '@/config/axios'
import publicInstance, { ApiError } from '@/config/axiosPublic'

export const fetchMotivations = async () => {
  try {
    const { data } = await publicInstance.get('/v1/show-interest/motivations')
    return data
  } catch (error) {
    const apiError = error as ApiError
    throw apiError
  }
}

export const registerHubUsers = async ({
  userInfo,
  interests,
  additionalThoughts,
  acknowledgementInfo,
}: InterestRegisterPayload) => {
  const response = await publicInstance.post(`/v1/show-interest/register`, {
    ...userInfo,
    selected_options: [...interests],
    custom_option: additionalThoughts,
    ...acknowledgementInfo,
  })
  return response.data
}

export const fetchPromptVid = async ({ prompt }: { prompt: string }) => {
  try {
    const { data } = await axiosInstance.post('/v1/prompt-vid', { prompt })
    return data
  } catch (error) {
    const apiError = error as ApiError
    throw apiError
  }
}
